<template>
  <div>
    <div class="mb-6">
      <h3 class="headline"><ressource code="resultats" hide-if-empty></ressource></h3>
      <template v-if="loading">
        <opq-loading size="200"></opq-loading>
      </template>
      <template v-else>
        <p class="body-1" v-if="cartesAffairesAbregees">{{ cartesAffairesAbregees.length }} résultats</p>
        <p class="body-1" v-else><ressource code="effectuez-recherche"></ressource></p>
      </template>
    </div>

    <template v-if="!loading && cartesAffairesAbregees && cartesAffairesAbregees.length > 0">
      <v-data-table
        :headers="headers"
        :items="cartesAffairesAbregees"
        :items-per-page="25"
        :footer-props="{ itemsPerPageOptions: [10, 25, 50, -1] }"
        disable-sort
        class="transparent"
      >
        <template v-slot:item.nom="{ item }"> {{ item.nom }}, {{ item.prenom }} </template>
        <template v-slot:item.details="{ item }">
          <template v-if="item.consentement">
            <a href="#" @click.prevent="$emit('carte-affaire-selected', item.idContact)" small color="primary">Voir la fiche →</a>
          </template>
          <template v-else>
            <ressource code="informations-confidentielles"></ressource>
          </template>
        </template>
      </v-data-table>
    </template>
    <template v-else> </template>
  </div>
</template>

<script>
export default {
  props: {
    cartesAffairesAbregees: {
      type: Array
    },
    detailsConnus: {
      type: Array,
      default() {
        return []
      }
    },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      headers: [
        {
          text: "Nom, Prénom",
          align: "start",
          value: "nom"
        },
        {
          text: "Informations",
          value: "details",
          align: "start"
        }
      ]
    }
  },
  methods: {
    goTo(id) {
      this.$router.push({ name: "RepertoireDetails", params: { id } })
    }
  }
}
</script>

<style>
</style>